/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import NumberField from './NumberField';
import { uFlexColumn } from '../../assets/styles/utility';
import { mediaBelow, pxToRem, pxToRemMd } from '../../assets/styles/helper';
import themeColors from '../../assets/styles/themeColors';
import { variables } from '../../assets/styles/variables';
import { ReactComponent as PlusIcon } from '../../assets/images/svg/quantity-plus.svg';
import { ReactComponent as MinusIcon } from '../../assets/images/svg/quantity-minus.svg';
import { ReactComponent as Switch } from '../../assets/images/svg/switch.svg';
import { ReactComponent as HandCoins } from '../../assets/images/svg/hand-coins.svg';
import Paragraph from '../Paragraph/Paragraph';
import { formatMoneyNumeral } from '../../util/helpers/numeralHelpers';
import { getActiveTierLabel as getActiveTierLabelHelper } from '../../util/helpers/buyOrderHelpers';
import {
  GS_MIN_DELIVERY_VALUE,
  NEW_YORK_MIN_ORDER_VALUE,
} from '../../util/constants';

const getActiveTypeStyles = (activeType) => {
  if (activeType === 'Cash') {
    return `
      > :first-child {
          background-color: ${themeColors.colorButtonPrimary};
          color: ${themeColors.colorWhite} !important;
      }
    `;
  }

  if (activeType === 'Quantity') {
    return `
      > :last-child {
          background-color: ${themeColors.colorButtonPrimary};
          color: ${themeColors.colorWhite} !important;
      }
    `;
  }
};

export const BuyFieldsContainer = styled.div`
  ${uFlexColumn};
  align-items: center;
  width: 100%;
  margin-bottom: ${pxToRem(16)};
`;

export const BuyFieldsButtonsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 0 0 ${pxToRem(24)};

  > button {
    border: 1px solid ${themeColors.colorButtonPrimary};
    color: ${themeColors.colorButtonPrimary};
    font-size: ${pxToRem(16)};
    line-height: 1.5;
  }

  > :first-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: 0;
  }

  > :last-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  ${({ activeType }) => getActiveTypeStyles(activeType)};

  ${mediaBelow(variables.breakpoints.bpMd)} {
    margin: 0 0 ${pxToRemMd(24)};
  }
`;

export const buyFieldsSelectedButton = css`
  background-color: ${themeColors.colorPrimary};
  color: ${themeColors.colorWhite} !important;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
justify-content: space-between;z2wddddwdddddw
  gap: 12px;
  height: 52px;
  margin: 20px 0 16px;
  padding: 0 ${pxToRem(12)};
  position: relative;
  border: 1px solid transparent;
  border-radius: 8px;
  background: ${themeColors.colorBackgroundSecondary};
  cursor: text;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:hover {
    border-color: ${themeColors.colorCardBorder};
  }

  &:focus-within {
    border-color: ${themeColors.colorButtonPrimary};
    box-shadow: 0 0 0 1px ${themeColors.colorButtonPrimary};
  }

  input {
    width: 100%;
    height: 100%;
    min-width: 0;
    text-align: center;
    font-family: ${({ isGS }) => isGS && variables.family.goldSilverHeaders};
    font-size: ${pxToRem(42)};
    font-weight: 600;
    padding: 0 10px;
    border: 0;
    outline: none;
    background: transparent;
    color: ${themeColors.colorTextPrimary};
    cursor: text;

    ::placeholder {
      color: ${themeColors.colorTextPrimary};
      opacity: 1;
    }
  }

  button {
    flex-shrink: 0;
    width: ${pxToRem(44)};
    height: ${pxToRem(44)};
    border-radius: ${variables.borderRadius.borderRadius};
    border: 0;
    background: transparent;
    cursor: pointer;
    transition: background 0.2s;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover:not(:disabled) {
      background: #eee;
    }
  }

  ${mediaBelow(variables.breakpoints.bpMd)} {
    input {
      font-size: ${pxToRemMd(36)};
    }
    button {
      width: ${pxToRemMd(36)};
      height: ${pxToRemMd(36)};
      svg {
        width: ${pxToRemMd(22)};
        height: ${pxToRemMd(22)};
      }
    }
  }
`;

const InputLabel = styled.p`
  width: 100%;
  margin: 20px 0 -12px;
  font-size: ${pxToRem(16)};
  font-weight: 500;
  color: ${themeColors.colorTextSecondary};

  ${mediaBelow(variables.breakpoints.bpMd)} {
    font-size: ${pxToRemMd(14)};
  }
`;

const InputContent = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;
`;

const DollarSign = styled.span`
  position: absolute;
  top: 50%;
  left: ${pxToRem(4)};
  transform: translateY(-50%);
  z-index: 1;
  pointer-events: none;
  font-family: ${({ isGS }) => isGS && variables.family.goldSilverHeaders};
  font-size: ${pxToRem(24)};
  font-weight: 400;
  color: ${themeColors.colorTextPrimary};
  opacity: 0.5;

  ${mediaBelow(variables.breakpoints.bpMd)} {
    font-size: ${pxToRemMd(20)};
  }
`;

const ToggleButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  p {
    font-size: ${pxToRem(14)};
  }

  svg {
    margin-right: 2px;
  }

  ${mediaBelow(variables.breakpoints.bpMd)} {
    p {
      font-size: ${pxToRemMd(12)};
    }
    svg {
      width: ${pxToRemMd(14)};
    }
  }
`;

const CalculatedValues = styled(Paragraph)`
  font-size: ${pxToRem(16)};
  text-align: center;
  margin: 0 auto;
  color: ${themeColors.colorTextPrimary};
  padding: 0 ${pxToRem(20)};
  border-bottom: ${({ hasAccountBalance }) =>
    hasAccountBalance
      ? `0.5px solid ${themeColors.colorBorderPrimary}`
      : 'none'};

  ${mediaBelow(variables.breakpoints.bpMd)} {
    font-size: ${pxToRemMd(14)};
    margin: 0 auto;
  }
`;

const SavingInfo = styled(Paragraph)`
  font-size: ${pxToRem(14)};
  color: ${themeColors.colorSuccess};
  margin-top: ${pxToRem(9)};

  svg {
    display: inline-block;
    vertical-align: middle;
    margin-right: ${pxToRem(4)};
  }

  ${mediaBelow(variables.breakpoints.bpMd)} {
    font-size: ${pxToRemMd(12)};
    margin-top: ${pxToRemMd(8)};
  }
`;

const CalculatedValuesWrapper = styled.div`
  background-color: ${themeColors.colorPrimaryLight};
  border: 1px solid ${themeColors.colorCardBorder};
  padding: ${pxToRem(10)};
  max-width: ${pxToRem(402)};
  width: 100%;
  margin-top: ${pxToRem(16)};
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: ${pxToRem(5)};
  ${mediaBelow(variables.breakpoints.bpMd)} {
    max-width: ${pxToRemMd(274)};
    margin-top: ${pxToRemMd(18)};
  }
`;

const BalanceInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${pxToRem(9)};
`;

const BalanceInfoTitle = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${themeColors.colorTextSecondary};
`;

const BalanceInfoValue = styled.p`
  font-size: 14px;
  font-weight: 700;
  color: ${themeColors.colorTextSecondary};
`;

const ShippingChargesInfo = styled.p`
  font-size: 14px;
  color: ${themeColors.colorTextSecondary};
  margin-top: ${pxToRem(9)};
  ${mediaBelow(variables.breakpoints.bpMd)} {
    margin-top: ${pxToRemMd(8)};
  }
`;

const MAX_CHARS = '10';
const MAX_VALUE = 9999999999;
const MAX_CASH_DECIMALS = 2;

const BuyInputFields = ({
  activeType,
  setActiveType,
  values,
  setFieldValue,
  unitPrice,
  priceCCPerUnit,
  setFieldTouched,
  setPricePerUnit,
  setPriceCCPerUnit,
  selectedPaymentMethod,
  setSavingAmount,
  productTiers,
  setOrderValues,
  isGS,
  isPostPaidVisible,
  availableForTrading,
  activeTab,
  setTotalPriceBasedOnPaymentMethod,
  setActiveTierLabel,
  selectedAddress,
}) => {
  const { t } = useTranslation();

  const isSelectedCreditCardPaymentMethod =
    selectedPaymentMethod?.PaymentMethodType === 3;

  const priceBasedOnPaymentMethod = isSelectedCreditCardPaymentMethod
    ? priceCCPerUnit
    : unitPrice;

  const [debouncedAmount, setDebouncedAmount] = useState(0);
  const amount =
    activeType === 'dollars' ? values.CashAmount : values.QuantityAmount;

  useEffect(() => {
    if (!amount || amount === '0' || amount === 0) {
      setDebouncedAmount(0);
      return;
    }

    const handler = setTimeout(() => {
      setDebouncedAmount(amount);
    }, 200);

    return () => clearTimeout(handler);
  }, [amount, activeType]);

  useEffect(() => {
    if (!productTiers?.Tiers?.length || !debouncedAmount) return;

    const effectiveAmount =
      activeType === 'quantity'
        ? debouncedAmount * priceBasedOnPaymentMethod
        : debouncedAmount;

    const matchedTier = productTiers.Tiers.find((tier) => {
      if (!tier.HighBound && tier.LowBound <= effectiveAmount) return true;
      if (tier.HighBound >= effectiveAmount && tier.LowBound <= effectiveAmount)
        return true;
      return false;
    });

    if (!matchedTier) return;

    setPriceCCPerUnit((prev) => {
      const newValue = matchedTier.BuyCCPricePerUnit;
      return prev !== newValue ? newValue : prev;
    });
    setPricePerUnit((prev) => {
      const newValue = matchedTier.PricePerUnit;
      return prev !== newValue ? newValue : prev;
    });
  }, [
    productTiers?.Tiers,
    debouncedAmount,
    activeType,
    isSelectedCreditCardPaymentMethod,
  ]);

  const clampQuantity = (value) =>
    String(value).replace(/\D/g, '').slice(0, MAX_CHARS);

  const clampCash = (value) => {
    const sanitized = String(value).replace(/[^\d.]/g, '');
    const firstDot = sanitized.indexOf('.');
    const normalized =
      firstDot === -1
        ? sanitized
        : `${sanitized.slice(0, firstDot + 1)}${sanitized
            .slice(firstDot + 1)
            .replace(/\./g, '')}`;
    const [intPart = '', decPart] = normalized.split('.');
    const intClamped = intPart.slice(0, MAX_CHARS);
    if (decPart === undefined) return intClamped;
    return `${intClamped}.${decPart.slice(0, MAX_CASH_DECIMALS)}`;
  };
  const isMaxReached = Number(values.QuantityAmount) === MAX_VALUE;

  const handleIncrease = () => {
    if (activeType !== 'quantity') return;

    const currentValue = values.QuantityAmount ?? '';
    const currentNumber = Number(currentValue) || 0;

    if (currentNumber === MAX_VALUE) return;

    const next = currentNumber + 1;

    if (String(next).length > MAX_CHARS) return;

    setFieldTouched('QuantityAmount', true);
    setFieldValue('QuantityAmount', next);

    setOrderValues((prev) => ({
      ...prev,
      QuantityAmount: next,
    }));
  };

  const handleDecrease = () => {
    if (activeType === 'quantity') {
      const next = (Number(values.QuantityAmount) || 0) - 1;
      setFieldTouched('QuantityAmount');
      setFieldValue('QuantityAmount', next > 0 ? next : '');
      setOrderValues((prev) => ({
        ...prev,
        QuantityAmount: next > 0 ? next : '',
      }));
    }
  };

  const handleKeyDown = (event) => {
    const invalidKeys = ['e', 'E', '+', '-'];
    if (invalidKeys.includes(event.key)) {
      event.preventDefault();
      return;
    }

    if (activeType !== 'quantity') return;

    if (event.key === 'ArrowUp') {
      event.preventDefault();
      handleIncrease();
    } else if (event.key === 'ArrowDown') {
      event.preventDefault();
      handleDecrease();
    }
  };

  const focusInput = (event) => {
    if (event.target.closest('button')) return;
    const input = event.currentTarget.querySelector('input');
    if (input) input.focus();
  };

  const toggleactiveType = () => {
    setActiveType((prev) => {
      const next = prev === 'quantity' ? 'dollars' : 'quantity';
      setOrderValues((prevVals) => ({
        ...prevVals,
        activeType: next,
      }));
      return next;
    });
  };

  const quantity =
    activeType === 'quantity'
      ? Number(values.QuantityAmount || 0)
      : Math.floor(
          (Number(values.CashAmount) || 0) / priceBasedOnPaymentMethod,
        );

  const totalPrice = quantity * unitPrice;
  const totalCCPrice = quantity * priceCCPerUnit;
  const priceCashCardDifference = totalCCPrice - totalPrice;
  const totalPriceBasedOnPaymentMethod =
    selectedPaymentMethod?.PaymentMethodType === 3 ? totalCCPrice : totalPrice;

  useEffect(() => {
    if (!priceCashCardDifference) {
      setSavingAmount(0);
    }
    if (priceCashCardDifference) {
      setSavingAmount(priceCashCardDifference);
    }
  }, [priceCashCardDifference]);

  useEffect(() => {
    setTotalPriceBasedOnPaymentMethod(totalPriceBasedOnPaymentMethod);
  }, [totalPriceBasedOnPaymentMethod]);

  useEffect(() => {
    if (!totalPriceBasedOnPaymentMethod) {
      setActiveTierLabel(null);
      return;
    }
    if (!productTiers?.Tiers?.length) return;
    const label = getActiveTierLabelHelper(
      productTiers.Tiers,
      totalPriceBasedOnPaymentMethod,
    );
    setActiveTierLabel(label);
  }, [productTiers, totalPriceBasedOnPaymentMethod]);

  const isAccountBalancePayment =
    selectedPaymentMethod?.PaymentMethodType === 1;

  const hasCalculation = quantity > 0 || totalPriceBasedOnPaymentMethod > 0;

  const hasAccountBalance =
    isAccountBalancePayment && Number(availableForTrading) > 0;

  const shouldShowWrapper =
    hasAccountBalance || (!isAccountBalancePayment && hasCalculation);

  return (
    <BuyFieldsContainer>
      <InputLabel>
        {t(
          activeType === 'dollars'
            ? 'buyWizard.dollarAmountLabel'
            : 'buyWizard.quantityLabel',
        )}
      </InputLabel>
      {activeType === 'dollars' && (
        <InputWrapper onClick={focusInput}>
          <InputContent>
            <DollarSign isGS={isGS}>$</DollarSign>
            <Field name="CashAmount">
              {({ field, form }) => (
                <NumberField
                  placeholder={0}
                  name="CashAmount"
                  component={NumberField}
                  centerText
                  autoFocus
                  field={field}
                  form={form}
                  isGS={isGS}
                  hideError
                  autoComplete="off"
                  onChange={(e) => {
                    const clamped = clampCash(e.target.value);
                    setFieldValue('CashAmount', clamped);
                    setFieldTouched('CashAmount', true);

                    setOrderValues((prev) => ({
                      ...prev,
                      CashAmount: clamped,
                    }));
                  }}
                  onKeyDown={handleKeyDown}
                  // disabled={IsCashOrderOnly}
                  value={values.CashAmount || ''}
                  data-cy="input-quantity"
                  maxlength={MAX_CHARS}
                />
              )}
            </Field>
          </InputContent>
        </InputWrapper>
      )}
      {activeType === 'quantity' && (
        <>
          <InputWrapper onClick={focusInput}>
            <button
              type="button"
              onClick={handleDecrease}
              disabled={
                !values.QuantityAmount || Number(values.QuantityAmount) === 0
              }
            >
              <MinusIcon width={26} />
            </button>

            <Field name="QuantityAmount">
              {({ field, form }) => (
                <NumberField
                  placeholder={0}
                  name="QuantityAmount"
                  component={NumberField}
                  centerText
                  autoFocus
                  clearPlaceholderOnFocus={false}
                  field={field}
                  form={form}
                  hideError
                  preventAllExceptNumbers
                  onChange={(e) => {
                    const clamped = clampQuantity(e.target.value);
                    setFieldValue('QuantityAmount', clamped);
                    setFieldTouched('QuantityAmount', true);

                    setOrderValues((prev) => ({
                      ...prev,
                      QuantityAmount: clamped,
                    }));
                  }}
                  onKeyDown={handleKeyDown}
                  value={values.QuantityAmount ?? ''}
                  // disabled={IsCashOrderOnly}
                  data-cy="input-quantity"
                  maxlength={MAX_CHARS}
                />
              )}
            </Field>

            <button
              type="button"
              onClick={handleIncrease}
              disabled={isMaxReached}
            >
              <PlusIcon width={26} />
            </button>
          </InputWrapper>
        </>
      )}
      {/* Toggle Button */}
      <ToggleButton onClick={toggleactiveType}>
        <Switch />
        <Paragraph>
          {t('buyWizard.switchTo')}{' '}
          {activeType === 'quantity' ? 'Dollar' : 'Quantity'}
        </Paragraph>
      </ToggleButton>

      {/* {activeType === 'Quantity' && IsCashOrderOnly && <CashOrderOnly />} */}

      {/* {isPostPaidVisible &&
        (
          <CalculatedValuesWrapper>
            {activeType === 'quantity' && (
              <CalculatedValues isPostPaid={isPostPaidVisible}>
                {quantity} {quantity > 1 ? 'Units' : 'Unit'} ={' '}
                <b>{formatMoneyNumeral(totalPriceBasedOnPaymentMethod)}</b>
              </CalculatedValues>
            )}
            {activeType === 'dollars' && (
              <CalculatedValues isPostPaid={isPostPaidVisible}>
                {formatMoneyNumeral(totalPriceBasedOnPaymentMethod)} ={' '}
                <b>
                  {quantity} {quantity > 1 ? 'Units' : 'Unit'}
                </b>
              </CalculatedValues>
            )}
            <BalanceInfoWrapper>
            <BalanceInfoTitle>
              {t('buyWizard.availableBalance')}
            </BalanceInfoTitle>
            <BalanceInfoValue>
              {formatMoneyNumeral(availableForTrading)}
            </BalanceInfoValue>
          </BalanceInfoWrapper>
            {selectedPaymentMethod?.PaymentMethodType !== 3 && (
              <SavingInfo>
                <HandCoins />
                {t('buyWizard.savingInfo1')}
                <b> {formatMoneyNumeral(priceCashCardDifference.toFixed(2))}</b>
                {t('buyWizard.savingInfo2')}
              </SavingInfo>
            )}
          </CalculatedValuesWrapper>
        )} */}
      {/* {!isPostPaidVisible && ( */}
      {shouldShowWrapper && (
        <CalculatedValuesWrapper>
          {hasCalculation && (
            <>
              {activeType === 'quantity' && (
                <CalculatedValues hasAccountBalance={hasAccountBalance}>
                  {quantity} {quantity > 1 ? 'Units' : 'Unit'} ={' '}
                  <b>{formatMoneyNumeral(totalPriceBasedOnPaymentMethod)}</b>
                </CalculatedValues>
              )}

              {activeType === 'dollars' && (
                <CalculatedValues hasAccountBalance={hasAccountBalance}>
                  {formatMoneyNumeral(totalPriceBasedOnPaymentMethod)} ={' '}
                  <b>
                    {quantity} {quantity > 1 ? 'Units' : 'Unit'}
                  </b>
                </CalculatedValues>
              )}
            </>
          )}

          {isAccountBalancePayment && (
            <BalanceInfoWrapper>
              <BalanceInfoTitle>
                {t('buyWizard.availableBalance')}
              </BalanceInfoTitle>
              <BalanceInfoValue>
                {formatMoneyNumeral(availableForTrading)}
              </BalanceInfoValue>
            </BalanceInfoWrapper>
          )}
          {isGS &&
            activeTab === 'delivery' &&
            totalPriceBasedOnPaymentMethod <=
              (selectedAddress?.StateRegion === 'NY'
                ? NEW_YORK_MIN_ORDER_VALUE
                : GS_MIN_DELIVERY_VALUE) && (
              <ShippingChargesInfo>
                {t('buyWizard.shippingChargesInfo', {
                  amount:
                    selectedAddress?.StateRegion === 'NY'
                      ? NEW_YORK_MIN_ORDER_VALUE
                      : GS_MIN_DELIVERY_VALUE,
                })}
              </ShippingChargesInfo>
            )}
          {isPostPaidVisible &&
            (selectedPaymentMethod?.PaymentMethodType === 1 ||
              selectedPaymentMethod?.PaymentMethodType === 2) &&
            priceCashCardDifference > 0 &&
            hasCalculation && (
              <SavingInfo>
                <HandCoins />
                {t('buyWizard.savingInfo1')}
                <b> {formatMoneyNumeral(priceCashCardDifference.toFixed(2))}</b>
                {t('buyWizard.savingInfo2')}
              </SavingInfo>
            )}
        </CalculatedValuesWrapper>
      )}
      {/* )} */}
    </BuyFieldsContainer>
  );
};

BuyInputFields.propTypes = {
  values: PropTypes.shape({
    CashAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    QuantityAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  activeType: PropTypes.string,
  setActiveType: PropTypes.func,
  setFieldValue: PropTypes.func,
  setFieldTouched: PropTypes.func,
  deliveryFees: PropTypes.shape({}),
  unitPrice: PropTypes.number,
  setPricePerUnit: PropTypes.func,
  priceCCPerUnit: PropTypes.number,
  setOrderValues: PropTypes.func,
  setPriceCCPerUnit: PropTypes.func,
  selectedPaymentMethod: PropTypes.shape({
    PaymentMethodType: PropTypes.number,
  }),
  setSavingAmount: PropTypes.func,
  productTiers: PropTypes.shape({
    Tiers: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  isGS: PropTypes.bool,
  isPostPaidVisible: PropTypes.bool,
  availableForTrading: PropTypes.number,
  activeTab: PropTypes.string,
  setTotalPriceBasedOnPaymentMethod: PropTypes.func,
  setActiveTierLabel: PropTypes.func,
  selectedAddress: PropTypes.shape({
    StateRegion: PropTypes.string,
  }),
};

export default BuyInputFields;
